import { type DocumentNode, gql } from '@apollo/client';

const editCollection: DocumentNode = gql`
  mutation update($collectionId: ID!, $collectionType: String, $name: String, $assetIds: [ID], $autoSeq: Boolean) {
    updateCollection(
      collectionId: $collectionId
      collectionType: $collectionType
      name: $name
      assetIds: $assetIds
      autoSeq: $autoSeq
    ) {
      __typename
      collection {
        name
        items {
          edges {
            node {
              sequence
              contentObject {
                ... on AssetNodeType {
                  id
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default editCollection;
